var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, } from 'react';
import { C } from '#integrations';
import styles from './Box.module.css';
const ORIENTATION_CLASS_MAP = {
    horizontal: styles.Row,
    vertical: styles.Column,
};
const JUSTIFY_CLASS_MAP = {
    start: styles.JustifyStart,
    center: styles.JustifyCenter,
    between: styles.JustifyBetween,
    end: styles.JustifyEnd,
};
const ALIGN_CLASS_MAP = {
    start: styles.AlignStart,
    center: styles.AlignCenter,
    end: styles.AlignEnd,
};
const GAP_CLASS_MAP = {
    '2xs': styles.Gap2XS,
    xs: styles.GapXS,
    s: styles.GapS,
    sm: styles.GapSM,
    m: styles.GapM,
    l: styles.GapL,
    xl: styles.GapXL,
    '2xl': styles.Gap2XL,
    '3xl': styles.Gap3XL,
    '10x': styles.Gap10x,
    '36x': styles.Gap36x,
};
const KIND_CLASS_MAP = {
    flex: styles.Flex,
    level1: styles.Level1,
    level2: styles.Level2,
    level2a: styles.Level2a,
    level3: styles.Level3,
    level4: styles.Level4,
};
const RADIUS_CLASS_MAP = {
    '2xs': styles.Radius2XS,
    xs: styles.RadiusXS,
    s: styles.RadiusS,
    sm: styles.RadiusSM,
    m: styles.RadiusM,
    l: styles.RadiusL,
    xl: styles.RadiusXL,
    '2xl': styles.Radius2XL,
    '3xl': styles.Radius3XL,
    '10x': styles.Radius10x,
    '36x': styles.Radius36x,
};
const SHADOW_CLASS_MAP = {
    deep: styles.ShadowDeep,
    shallow: styles.ShadowShallow,
};
const WIDTH_CLASS_MAP = {
    xxs: styles.WidthXXS,
    xs: styles.WidthXS,
    s: styles.WidthS,
    sm: styles.WidthSM,
    m: styles.WidthM,
    l: styles.WidthL,
    xl: styles.WidthXL,
    '2xl': styles.Width2XL,
};
const BASIS_CLASS_MAP = {
    xxs: styles.BasisXXS,
    xs: styles.BasisXS,
    s: styles.BasisS,
    sm: styles.BasisSM,
    m: styles.BasisM,
    l: styles.BasisL,
    xl: styles.BasisXL,
    '2xl': styles.Basis2XL,
};
const ZERO_PADDING_SIZE = '0';
const getPaddingStyle = (padding) => {
    if (!padding) {
        return undefined;
    }
    const paddingArray = padding
        .trim()
        .split(' ')
        .map((element) => element.trim());
    if (!paddingArray.length) {
        return undefined;
    }
    return paddingArray
        .map((element) => {
        if (element === ZERO_PADDING_SIZE) {
            return ZERO_PADDING_SIZE;
        }
        return `var(--ds-${element})`;
    })
        .join(' ');
};
export const Box = ({ align, ariaLabel, ariaLive, as = 'div', basis, children, className, 'data-testid': testid, gap, grow, hasBorder = true, id, inert, isFullHeight = false, isFullWidth = false, isMuted = false, isVisuallyHidden = false, justify = 'start', kind = 'flex', orientation = 'horizontal', padding, radius, ref, scrollableY, shadow, shrink, width, wrap = false, }) => {
    _react_refresh_temp_2();
    const Component = as;
    const style = useMemo(() => ({ padding: getPaddingStyle(padding) }), [padding]);
    return (_jsx(Component, { className: C(styles.Container, align && ALIGN_CLASS_MAP[align], basis && BASIS_CLASS_MAP[basis], gap && GAP_CLASS_MAP[gap], grow === 0 && styles.PreventGrow, grow === 1 && styles.AllowGrow, !hasBorder && styles.NoBorder, JUSTIFY_CLASS_MAP[justify], KIND_CLASS_MAP[kind], ORIENTATION_CLASS_MAP[orientation], radius && RADIUS_CLASS_MAP[radius], wrap && styles.Wrap, isFullHeight && styles.FullHeight, isFullWidth && styles.FullWidth, isMuted && styles.Muted, isVisuallyHidden && styles.VisuallyHidden, className, scrollableY && styles.ScrollableY, shadow && SHADOW_CLASS_MAP[shadow], shrink === 0 && styles.PreventShrink, shrink === 1 && styles.AllowShrink, width && WIDTH_CLASS_MAP[width]), style: style, ...(id ? { id } : {}), ...(ref ? { ref } : {}), ...(inert ? { inert: true } : {}), ...(testid ? { 'data-testid': testid } : {}), ...(as === 'dialog' ? { tabIndex: -1 } : {}), ...(ariaLabel && { 'aria-label': ariaLabel }), ...(ariaLive && { 'aria-live': ariaLive }), children: children }));
};
_react_refresh_temp_1 = Box;
$RefreshReg$(_react_refresh_temp_1, "Box");
_react_refresh_temp_2(Box, "03TOej/Atx47IHUj0GasUXSIbAc=");
